// LineChart.jsx
import React, { useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsTheme from "./chartsTheme";

Highcharts.setOptions(HighchartsTheme.dark);
const LineChart = (props) => {
  let chartId = props.chartId ? props.chartId : "chart-cr";
    useEffect(() => {
        if (chartId == 'print_rslt') {
            Highcharts.setOptions(HighchartsTheme.light);
        } else Highcharts.setOptions(HighchartsTheme.dark);
    let series1Data = props?.chartData?.map((obj) => {
      return [obj.resultDate, parseInt(obj.target)];
    });
    let series2Data = props?.chartData?.map((obj) => {
      return [obj.resultDate, parseInt(obj.actual)];
    });

    const data1 = series1Data;

    const data2 = series2Data;

    // get Dates Data
    const dates = data1.map(([date]) => date);
    // Create the chart
    Highcharts.chart(chartId, {
      chart: {
        type: "line",
      },
      title: {
        text: "Confirmed Results",
      },
      xAxis: {
        categories: dates, // Use the extracted dates
      },
      yAxis: {
        title: {
          text: "Percentage",
        },
        min: 0,
        max: 100,
      },
      series: [
        {
          name: props.target,
          data: data1,
          type: "line",
        },
        {
          name: props.actual,
          data: data2,
          color: "orange",
          type: "line",
        },
      ],
    });

    // Render the chart
  }, [props?.chartData, props.actual, props.target, props.chartId]);

  if (props?.chartData !== undefined) return <div id={chartId}></div>;
  else return null;
};

export default LineChart;
